import { DIM2CLASS } from '../core/icon-class';

class FilterSearchController {
  constructor(
    $scope,
    CurrentFilterService,
    AggregateDataService,
    CurrentModelService,
    RouterService,
  ) {
    this.$scope = $scope;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = DIM2CLASS;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.router = RouterService;
    this.value ='';
  }

  get panel() {
    return this.currentFilter.panel;
  }

  set panel(panel) {
    this.currentFilter.panel = panel;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  searchKeyup(event) {
    if (event.keyCode !== 13) {
      return;
    }
    return this.search();
  }

  search() {
    let keywords = this.value;
    if (!keywords.trim()) {
      return;
    }
    let re = (keywords.match(/["'](.*)["']/));
    if (re) {
      this.router.addKeyword(re[1]);
    } else {
      keywords.split(' ').forEach((keyword) => {
        this.router.addKeyword(keyword);
      });
    }
    this.value = '';
  }

}

export function FilterSearchComponent() {
  return {
    restrict    : 'E',
    template    : require('./filter-search.component.html'),
    scope       : true,
    controller  : FilterSearchController,
    controllerAs: '$ctrl',
  };
}



// WEBPACK FOOTER //
// ./src/filter/filter-search.component.js